<template>
  <!--    Register in Shaparak Modal-->
  <b-modal
    ref="my-modal"
    v-model="visibility"
    :title="$translate('paymentMethodSelection')"
    header-class="justify-content-center position-relative"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div class="d-block direction-rtl">
      <b-row>
        <b-col cols="12" class="error-detail-text"
          >{{ $translate("selectYourPaymentMethod") }}
        </b-col>
      </b-row>
      <b-row class="m-0 pb-2">
        <b-form-radio-group
          v-model="selectedMethod"
          class="form-control d-flex flex-row justify-content-between btn-group-sm"
          :options="options"
          button-variant="outline-primary"
          buttons
          required
        ></b-form-radio-group>
      </b-row>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <button class="modal-button" @click="submitInfo">
            <span>{{ $translate("submit") }}</span>
          </button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
  <!--    Register in Shaparak Modal-->
</template>

<script>
import alertHelper from "@/helper/AlertHelper";
import { mapGetters } from "vuex";

export default {
  name: "ShaparakMethodSelectModal",
  props: {
    visibility: Boolean,
  },

  data() {
    return {
      options: [
        { value: "direct", text: this.$translate("directIranIpOnly") },
        { value: "indirect", text: this.$translate("indirect") },
      ],
      selectedMethod: "indirect",
    };
  },
  computed: {
    ...mapGetters(["getTransactionId"]),
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    selectShaparakMethodApi() {
      const transactionId = this.getTransactionId;
      alertHelper.loadingAlert();
      this.$http
        .post(`shaparak/${transactionId}/method`, {
          shaparak_method: this.selectedMethod,
        })
        .then(
          (res) => {
            if (res.body.status == 200) {
              if (this.selectedMethod === "direct") {
                // Redirect the user to another URL
                const redirectUrl = res.body.url;
                alertHelper.timerAlert(
                  this.$translate("redirecting"),
                  this.$translate("shaparakRedirectNotice"),
                  10000,
                  true,
                  () => {
                    window.location.href = redirectUrl;
                  }
                );
              } else {
                // Close the modal
                alertHelper.successAlert();
                this.closeModal();
              }
            } else {
              alertHelper.apiErrorAlert("", res.body.message);
              this.closeModal();
            }
          },
          (error) => {
            alertHelper.apiErrorAlert("", error.body.message);
          }
        );
    },
    async submitInfo() {
      this.selectShaparakMethodApi();
    },

    //Submit Information
  },
};
</script>

<style scoped>
.modal-button {
  width: 50%;
  padding: 5px;
  margin-top: 20px;
  color: #ffffff;
  border-radius: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: var(--dodger-blue);
  border: none;
}

.error-detail-text {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--midnight-blue);
  font-size: 0.8rem;
  text-align: center;
  padding-bottom: 15px;
}
</style>
